// Module
var code = `<div ng-repeat="choice in block.content.hideGradStudent ? block.content.staticChoices.slice(0,-1) : block.content.staticChoices" class="radio"> <label> <input type="radio" show-errors name="{{ block.id }}" ng-required="block.required" ng-model="answer.value" ng-model-options="{ debounce: 300 }" ng-value="choice"/> <strong>{{ choice }}</strong></label> </div> `;
// Exports
var _module_exports =code;;
var path = '/views/blocks/yearInSchoolQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;